export function couleurEtatComposant(etat){
  if(etat === 'Neuf'){
    return 'bg-green-500';
  } else if (etat === 'Bon état'){
    return 'bg-blue-500';
  } else if (etat === 'Moyen'){ 
    return 'bg-orange-500';
  }else {
    return 'bg-red-500';
  }
}